export default defineNuxtRouteMiddleware(async (to, _from) => {
    const { fetchUser, setUser } = useDirectusAuth();
    const user = useDirectusUser();

    if (!user.value) {
        try {
            const user = await fetchUser();
            setUser(user.value);
        } catch (e) {
        }
    }
});